import React, { useState, useEffect } from 'react';
import { supabase } from './supabase/supabaseClient.js';
import { useLocation, useNavigate } from 'react-router-dom'; // 🟢 เพิ่ม useNavigate
import { useTranslation } from 'react-i18next';
import { FaSearch, FaPhone, FaEnvelope, FaTimes } from 'react-icons/fa'; 
import "./App.css";
import "./products.css";

export default function Products() {
  
  const { t, i18n } = useTranslation(); 
  const currentLang = i18n.language ? i18n.language.split('-')[0] : 'th'; 
  const location = useLocation(); 
  const navigate = useNavigate(); // 🟢 เรียกใช้ navigate

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState(''); 
  const [selectedCategory, setSelectedCategory] = useState('ทั้งหมด'); 

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const { data: prodData, error: prodError } = await supabase
          .from('products')
          .select('*')
          .order('id', { ascending: true });
        
        if (prodError) throw prodError;
        if (prodData) setProducts(prodData);
      } catch (error) {
        console.error('Error:', error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (location.state && location.state.selectedCategory) {
      setSelectedCategory(location.state.selectedCategory);
      setSearchTerm(''); 
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      setSelectedCategory('ทั้งหมด');
    }
  }, [location.state]);

  const filteredProducts = products.filter((product) => {
    const matchCategory = selectedCategory === 'ทั้งหมด' || product.category === selectedCategory;
    const productName = (product[`name_${currentLang}`] || product.name || '').toLowerCase();
    const productDesc = (product[`description_${currentLang}`] || product.description || '').toLowerCase();
    const matchSearch = productName.includes(searchTerm.toLowerCase()) || 
                        productDesc.includes(searchTerm.toLowerCase());
    return matchCategory && matchSearch;
  });

  return (
    <section className="products-page">
      <div className="products-header">
        <h1>{t('ourProductsTitle', 'สินค้าของเรา')}</h1>
        
        {selectedCategory !== 'ทั้งหมด' && (
          <div className="category-tag-container">
            <div className="active-category-tag">
              <span>{t('category', 'หมวดหมู่')}: <strong>{selectedCategory}</strong></span>
              <button onClick={() => setSelectedCategory('ทั้งหมด')}>
                <FaTimes />
              </button>
            </div>
          </div>
        )}
      </div>

      <div className="products-controls">
        <div className="search-box">
          <FaSearch className="search-icon" />
          <input
            type="text"
            placeholder={t('searchProductPlaceholder', 'ค้นหาสินค้า...')}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      <div className="products-grid">
        {loading ? (
          <div className="loading-container"><div className="spinner"></div></div>
        ) : filteredProducts.length > 0 ? (
          filteredProducts.map((product) => (
            // 🟢 เปลี่ยนจากการเปิด Modal เป็น Navigate ไปที่หน้า ProductDetail
            <div key={product.id} className="product-card" onClick={() => navigate(`/product/${product.id}`)}>
              <div className="product-image-wrapper">
                <img src={product.image || 'https://via.placeholder.com/300'} alt={product.name} className="product-image" />
                <div className="product-overlay">
                  <span className="view-detail-btn">{t('viewDetail', 'ดูรายละเอียด')}</span>
                </div>
              </div>
              <div className="product-content">
                <span className="product-category-tag">{product.category}</span>
                <h3>{product[`name_${currentLang}`] || product.name}</h3>
                <p className="product-description">{product[`description_${currentLang}`] || product.description}</p>               
              </div>
            </div>
          ))
        ) : (
          <div className="no-products">
            <p>{t('noProductsFound', 'ไม่พบสินค้าในหมวดหมู่นี้')}</p>
            {selectedCategory !== 'ทั้งหมด' && (
              <button onClick={() => setSelectedCategory('ทั้งหมด')} className="reset-btn">ดูสินค้าทั้งหมด</button>
            )}
          </div>
        )}
      </div>

      <div className="products-cta">
        <div className="cta-content">
          <h2>{t('interestedOrConsult', 'สนใจสินค้าหรือต้องการคำปรึกษา?')}</h2>
          <div className="cta-buttons">
            <a href="tel:0906187997" className="cta-btn primary"><FaPhone /> {t('callToInquire', 'โทรสอบถาม')}</a>
            <a href="mailto:ascentcorp.info@gmail.com" className="cta-btn secondary"><FaEnvelope /> {t('sendEmail', 'ส่งอีเมล')}</a>
          </div>
        </div>
      </div>
    </section>
  );
}